/*global printJS*/
"use strict";

import $ from "jquery";
import "print.js/dist/print.min";

const isMSIE = () => !!window.document.documentMode;
// const isEdge = () => /edge/i.test(navigator.userAgent);
// const isMicrosoft = () => isMSIE() || isEdge();
// const isFirefox = () => /firefox/i.test(window.navigator.userAgent);
const isBadBrowser = () => isMSIE();

const printLinkClickedOld = function () {
  const printable = $(this).prop("href") + ".html";
  const features = "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes, width=800, height=600";
  const newWindow = window.open(printable, "printable", features);
  window.setTimeout(() => newWindow.print(), 4000);
};

const printLinkClickedNew = function () {
  const printable = $(this).prop("href") + ".html";
  printJS({ printable: printable, type: "pdf", showModal: true });
};

const printLinkClicked = function (e) {
  e.preventDefault();
  const printfn = isBadBrowser() ? printLinkClickedOld : printLinkClickedNew;
  printfn.apply(this);
};

const initPrint = function () {
  $("a[data-print]").on("click", printLinkClicked);
};

$(document).on("turbolinks:load", initPrint);

export default initPrint;
